import { Component, OnInit } from '@angular/core';
import { CompanyRespiratorInserts } from 'src/app/models/company-respirator-inserts.model';
import { PagedCollectionResponse } from 'src/app/models/http/page-collection-response.model';
import { SelectedInsert } from 'src/app/models/local-storage/selected-insert.model';
import { LocalStorageService } from 'src/app/services/local/local-storage.service';
import { CompanyRespiratorInsertsService } from 'src/app/services/repositories/company-respirator-inserts.service';

@Component({
    selector: 'app-respirators',
    templateUrl: './respirators.component.html',
    styleUrls: ['./respirators.component.scss'],
    standalone: false
})
export class RespiratorsComponent implements OnInit {
  toggleClass: boolean = true;
  respiratoryInserts: CompanyRespiratorInserts[] = [];
  totalItems: number = 0;
  currentPage: number = 1;

  constructor(private _companyRespiratorInsertsService: CompanyRespiratorInsertsService,
              private _localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    this.loadInserts();
  }

  loadInserts() {
    this._companyRespiratorInsertsService.getInserts()
      .subscribe((data: PagedCollectionResponse<CompanyRespiratorInserts>) => { // flat map to filter
        this.totalItems = data.totalResult;
        this.respiratoryInserts = data.items;
      }, (error: any) => {
        console.log(error);
      });
  }

  selectProduct(productId: number, style: string) {
    const selectedInsert : SelectedInsert = {
      companyInsertId: productId,
      style: style
    }
    this._localStorageService.setSelectedStyle(selectedInsert);
  }

}
